module.exports = __webpack_public_path__ + "static/img/platten.17390d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/platten.jpg
// module id = 300
// module chunks = 0